import { Reveal, Overline } from "./Reveal";
import { MINISTRIES } from "../../data/content";

export const Ministries = () => {
  return (
    <section id="ministries" data-testid="ministries-section" className="relative py-28 lg:py-40 bg-[#080808]">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <Reveal><Overline>The Ministries</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter max-w-2xl">
                Platforms built to <span className="text-gold-gradient italic">edify & empower</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-white/55 max-w-sm leading-relaxed">
              Edify. Motivate. Strengthen. Educate. A simple yet powerful mission to remind
              women of their God-given beauty, purpose, and worth.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {MINISTRIES.map((m, i) => (
            <Reveal key={m.title} delay={(i % 2) * 0.08} className={`col-span-1 ${m.span}`}>
              <article
                data-testid={`ministry-card-${i}`}
                className="group relative h-[380px] lg:h-[440px] overflow-hidden rounded-sm border border-white/10"
              >
                <img
                  src={m.image}
                  alt={m.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-45 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
                <div className="relative h-full flex flex-col justify-end p-8 lg:p-10">
                  <span className="text-[11px] uppercase tracking-[0.3em] text-gold/90">{m.tag}</span>
                  <h3 className="mt-3 font-serif text-3xl lg:text-4xl font-light tracking-tight">{m.title}</h3>
                  <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-md">{m.body}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
